import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
    title: "编辑页",
    "show-close": false,
    width: "660px",
    center: "",
    "append-to-body": "",
    onOpen: _ctx.handleOpen,
    onClose: _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-width": "120px",
        "label-position": "right",
        style: {"text-align":"left"},
        ref: "formRef",
        model: _ctx.formData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "项目名称：",
            prop: "newProjectName",
            rules: {required: true, message: '项目名称不能为空', trigger:'change'}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.formData.newProjectName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.newProjectName) = $event)),
                placeholder: "请输入项目名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "域名地址：",
            prop: "domainName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.formData.domainName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.domainName) = $event)),
                placeholder: "请输入域名地址"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen", "onClose"]))
}